export const BLOG_UI_TEXT_QUERY = `
  query BlogUIText($locale: SiteLocale!) {
    allBlogUiTexts(locale: $locale) {
      slug
      text
      description
      heroModal {
        __typename
        ... on ModalBlockRecord {
          icon {
            url
          }
          body
          button {
            ... on CtaBlockRecord {
              buttonText
              url
            }
          }
        }
      }
    }
  }
`
